import '@sd/messenger-ui/styles.css';
import { MessengerApp, watchInstallOffer } from '@sd/messenger-ui';
import { StrictMode, type ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { createWebPlatform } from './platform';

// Android browsers may offer installing before the first render: keep the offer for the messenger's own button.
watchInstallOffer();

// The server was updated while this page stayed open: the parts it loads later (settings, invitations, forwarding)
// are gone with the old version. Reload into the new one rather than fail, once a minute at most.
window.addEventListener('vite:preloadError', (event) => {
  try {
    const last = Number(sessionStorage.getItem('sd.preload-reload') ?? 0);
    if (Date.now() - last < 60_000) return;
    sessionStorage.setItem('sd.preload-reload', String(Date.now()));
  } catch {
    // Without storage, reload anyway: a broken dialog is worse.
  }
  event.preventDefault();
  window.location.reload();
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('root element missing');
const root = createRoot(rootElement);
const render = (node: ReactNode) => root.render(<StrictMode>{node}</StrictMode>);

const params = new URLSearchParams(window.location.search);
if (import.meta.env.DEV && params.get('fixture') === 'design') {
  // Dev-only: the design's sample data behind the real client engine (no server needed).
  // `import.meta.env.DEV` is false in production builds, so this branch and the fixtures are dropped.
  void import('./fixture').then(({ renderFixture }) => render(renderFixture(params)));
} else {
  render(<MessengerApp platform={createWebPlatform()} />);
}
